import(/* webpackMode: "eager" */ "/opt/build/repo/workspaces/apps/westside-barbell/app/global-error.tsx");
